<!--
    富文本编辑器
    作用：提供富文本字体颜色、字号、加粗、斜体、下划线等功能操作；
    实现：双击、浮动菜单；
    组件：原生开发、颜色组件
    注释：WJ
-->
<template>
  <div class="rich-text-edit" v-if="dialogVisible" @click.stop="exit()">
    <!-- 富文本设置弹窗 -->
    <div class="edit-setting" :style="editSetting" @click.stop="swithDrop()">
      <!-- 字体部分 -->
      <div class="edit-fontFamily">
        <p @click.stop="swithDrop('fontFamilySelect')">{{familySelect}}</p>
        <i @click.stop="swithDrop('fontFamilySelect')" class="icon-rich-text-drop"></i>
        <div v-show="fontFamilySelect" class="rich-dropdown">
          <div :class="{active: familySelect === f.value}" v-for="f in downFonts" :key="f.index" @click="changeFontFamily(f)">
            {{f.label}}
          </div>
          <!--div class="more-fontFamily" @click="moreFont">更多字体</div-->
        </div>
      </div>
      <!-- 字体大小 -->
      <div class="edit-fontSize">
        <input type="number" v-model="fontSize" @focus="focusF('fontSize')" @blur="blurF('fontSize')">
        <div class="size-dropdown">
          <div @click.stop="swithDrop('fontSizeSelect')"><i class="icon-rich-text-drop"></i></div>
          <div v-show="fontSizeSelect" class="size-drop-box">
            <div>
              <div v-for="(s,sindex) in sizeDrop" :key="sindex" @click="clickChangeSize(s)">{{`${s}px`}}</div>
            </div>
          </div>
        </div>
        <div class="add-size" @click="addReduSize(1)">
          <i class="icon-fontsize-add"></i>
        </div>
        <div class="redu-size" @click="addReduSize(-1)">
          <i class="icon-fontsize-cut"></i>
        </div>
      </div>
      <div class="line"></div>
      <!-- 颜色部分 -->
      <div class="edit-color">
        <div @click="showColorPicker({ whichPart: 'foreColor' });" >
          <span :style="{'borderColor': foreColor}">A</span>
          <colorPicker class="yanse-box" v-model="foreColor" v-on:change="setFontColor()" />
        </div>
        
        <div class="edit-remove" @click="doCommand({cmd: 'removeFormat', val: ''})">
            <i class="icon-rich-text-remove"></i>
        </div>
      </div>
      <!-- 基础部分 -->
      <div class="edit-basic">
        <div v-for="c in basicBtn" :key="c.index" @click.stop="changeBasic(c)">
          <i :class="c.icon"></i>
        </div>
      </div>
      <div class="line"></div>
      <!-- 行高，字间距 -->
      <div class="edit-layout">
        <div class="layout-justify">
          <div @click="changejustify('left')"><i class="icon-rich-text-left"></i></div>
          <div @click="changejustify('center')"><i class="icon-rich-text-center"></i></div>
          <div @click="changejustify('right')"><i class="icon-rich-text-right"></i></div>
        </div>
        <div class="layout-lineHeight">
          <div @click.stop="swithDrop('showLineHeight')">
            <i class="icon-rich-text-line"></i>
            <i class="icon-rich-text-drop"></i>
          </div>
          <div v-show="showLineHeight" class="lineHeight-dropdown">
            <input type="number" v-model="lineHeight" @click.stop @focus="focusF('lineHeight')" @blur="blurF('lineHeight')">
            <div v-for="l in lineDrop" :key="l.index" @click="clickChangeLine(l)">{{l}}</div>
          </div>
        </div>
        <!--div class="layout-letterSpacing">
          <div @click.stop="swithDrop('showLetterSpacing')">
            <i class="icon-rich-text-letter"></i>
            <i class="icon-rich-text-drop"></i>
          </div>
          <div v-show="showLetterSpacing" class="letterSpacing-dropdown">
            <input type="number" v-model="letterSpacing" @click.stop @focus="focusF('letterSpacing')" @blur="blurF('letterSpacing')">
            <div v-for="l in letterDrop" :key="l.index" @click="clickChangeLetter(l)">{{`${l}%`}}</div>
          </div>
        </div-->
      </div>
    </div>
    <!-- 富文本编辑div -->
    <div class="edit-content" :style="editContent" @click.stop="swithDrop()">
      <div
        class="my-edit"
        contentEditable="true"
        ref="myEdit"
        v-html="richText"
        :style="myEditStyle"
        @mouseup="synch($event)"
        @paste="paste($event)"
      >
      </div>
    </div>
  </div>
</template>


<script>
export default {
    name: 'richTextEdit',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        data: [Object, Array,String]
    },
    watch: {
        dialogVisible(vl) {
            this.$emit('update:visible', vl);
        },
        visible(vl) {
            if(vl)setTimeout(() => {
              this.init();
            },100);
        },
        data(vl){
            this.data=vl;
            this.newData = vl;
            let left=230;
            //console.log("当前数据：",this.data);
            let menusBox=document.getElementsByClassName("menus-box");
            if(menusBox[0].clientWidth===0)left=0;
            this.stylePos={
                width:this.data.value.position.width,
                height:this.data.value.position.height,
                top:(parseFloat(this.data.value.position.top)+10)+"px",
                left:(parseFloat(this.data.value.position.left)+left)+"px",
                fontSize:this.data.value.fontSize,//parseInt(parseFloat(this.data.value.fontSize)*this.data.value.position.scale)+"px",
                textAlign:"center"
            }
        },
        newData(vl){this.$emit('update:data',vl)}
    },
    data() {
        return {
            editorText: null,
            newData: this.data,
            dialogVisible: this.visible,
            textValue:this.data,
            htmlContent: '', // 富文本内容
            stylePos:{
                width:"350px",
                height:"60px",
                top:"0px",
                left:"0px",
                fontSize:"18px",
                textAlign:"center"
            },
            show: true, // 是否显示
            sprite: null,
            richText: '', // richText的innerHTML
            editContent: { // 编辑框的样式
                width: "0px",
                height: "auto",
                top: "-10px",
                left: "-10px",
                transform: 'rotate(0deg)'
            },
            editSetting: { // 设置弹窗的定位
                top: "-320px",
                left: "-320px",
            },
            myEditStyle: { // 可编辑div的样式
                lineHeight: 0,
                width: 'auto',
                height: 'auto',
                textAlign:'center',
                writingMode: 'inherit', //pre-wrap
                fontSize: '18px',
                color:'#000000',
                fontFamily: '"微软雅黑"'
            },
            fontFamily: '默认字体', // 选择位置的字体
            downFonts:[
                {value: 'Arial', label: 'Arial'},
                {value: '微软雅黑, Microsoft YaHei', label: '微软雅黑'},
                {value: 'SimHei', label: '黑体'},
                {value: 'SimSun', label: '宋体'},
                {value: '楷体, KaiTi', label: '楷体'},
                {value: '隶书, LiSu', label: '隶书'},
                {value: '华文彩云, STCaiyun', label: '华文彩云'},
                {value: '华文新魏, STXinwei', label: '华文新魏'},
                {value: 'Verdana', label: 'Verdana'},
                {value: 'Times New Roman', label: 'Times New Roman'},
                {value: 'Helvetica', label: 'Helvetica'},
                {value: 'Garamond', label: 'Garamond'},
                {value: 'Frutiger', label: 'Frutiger'},
                {value: 'Bodoni', label: 'Bodoni'},
            ],
            fontSize: 40, // 选择位置的字体大小
            fontSizeF: 40, // 用于获取最大字体大小
            selection: null, // window的getSelection对象
            sizeDrop: [12, 18, 24, 30, 40, 50, 60, 70, 80, 90, 100, 120, 150, 180, 200], // 字体大小常用数值
            lineDrop: [1.00, 1.25, 1.50, 1.75, 2.00, 2.5, 3.00, 3.5, 4.00], // 行高常用数值
            letterDrop: [0, 10, 25, 50, 75, 100], // 字间距的常用数值
            foreColor: '', // 选择位置文字的颜色
            basicBtn: [ // 基础按钮对象
                {
                    cmd: "bold",
                    icon: 'icon-rich-text-bold',
                    text: "加粗"
                },
                {
                    cmd: "italic",
                    icon: 'icon-rich-text-italic',
                    text: "倾斜"
                },
                {
                    cmd: "underline",
                    icon: 'icon-rich-text-under',
                    text: "下划线"
                }
            ],
            letterSpacing: 0, // 文字的字间距设置的值
            letterSpacingF: 0,
            lineHeight: 1.5, // 行高设置的值
            lineHeightF: 1,
            familySelect:'Microsoft YaHei',
            fontFamilySelect: false, // 字体下拉弹窗是否显示
            fontSizeSelect: false, // 字体大小下拉弹窗是否显示
            showLineHeight: false, // 行高下拉弹窗是否显示
            showLetterSpacing: false, // 字间距下拉弹窗是否显示
            useFontFamily: null, // 字体的set对象（用于存储使用的字体）
            writingMode: 'Horizontal' //Vertical
        };
    },
    methods: {
        init() {
            /*if(this.isJSON(this.data.value.html)){
              let htmlArr=JSON.parse(this.data.value.html);
              this.lineHeight=htmlArr.lineHeight;
              this.richText = htmlArr.html;
            }else{
              this.richText=this.cocosToHTML(this.data.value.text);
            }*/
            let left=230;
            let menusBox=document.getElementsByClassName("menus-box");
            if(menusBox[0].clientWidth===0)left=0;

            this.richText=this.data.value.html;
            this.familySelect=this.data.value.familySelect;
            this.editContent.width=parseFloat(this.data.value.position.width)/(this.data.value.position.scale)+"px";//this.data.value.position.width;
            this.editContent.height=parseFloat(this.data.value.position.height)/(this.data.value.position.scale)+"px";//this.data.value.position.height;
            this.editContent.top = (parseFloat(this.data.value.position.top)+54)+"px";
            this.editContent.left = (parseFloat(this.data.value.position.left)+left)+"px";
            this.editContent.transform="scale("+(this.data.value.position.scale)+")";
            this.myEditStyle.lineHeight = this.data.value.lineHeight;
            this.myEditStyle.fontSize=this.data.value.fontSize+"px";//Math.round(parseFloat(this.data.value.fontSize)*(this.data.value.position.scale))+"px";
            this.myEditStyle.fontFamily=this.data.value.familySelect;
            this.myEditStyle.color="#"+this.data.value.fontColor;
            this.myEditStyle.textAlign=(this.data.value.horizontalAlign=="0")?"left":((this.data.value.horizontalAlign=="2")?"right":"center");

            if(this.editSetting.top < 0) {
                this.editSetting.top = '0px';
            } else {
                this.editSetting.top += 'px';
            }
            if(this.editSetting.left < 0) {
                this.editSetting.left = '0px';
            } else {
                this.editSetting.left += 'px';
            }
            this.dialogVisible = true;
            
            this.editSetting.top = (parseFloat(this.data.value.position.top)-54)+'px';
            this.editSetting.left = (parseFloat(this.data.value.position.left)+230)+'px';
            
            // 关闭所有下拉弹窗
            this.swithDrop()

            //开始重新计算字体大小
            //this.resetFontSize("toHtml");
            document.execCommand('formatBlock', 'false', '<p>')
            
            this.startTimer();
            // 使用span元素而不是b标签等元素
            //document.execCommand('styleWithCSS', 0, true)
            // 使用p元素代理div元素
        },
        startTimer() { 
          const self = this;
          setTimeout(function() { 
            self.$refs.myEdit.focus();
            //let selection = window.getSelection(); //保存选择。 
            //let range = document.createRange();
            //range.selectNodeContents(self.$refs.myEdit);
            //selection.removeAllRanges(); //从选区中删除所有范围。 
            //selection.addRange(range); //添加新的范围。 
          }, 200) 
        },
        resetFontSize(_type){
          //开始重新计算字体大小
          let doms = null;
          doms = this.$refs.myEdit.querySelectorAll('[style]')
          doms.forEach((dom) => {
              if(_type=="toCocos"){
                if(dom.style.fontSize!="")dom.style.fontSize=Math.round(parseFloat(dom.style.fontSize)/(this.data.value.position.scale));
              }else{
                if(dom.style.fontSize!="")dom.style.fontSize=Math.round(parseFloat(dom.style.fontSize)*this.data.value.position.scale);
              }
          })
          doms = null;
        },
        swithDrop(type) {
            // 下拉弹窗的设置
            let drop = ['fontFamilySelect', 'fontSizeSelect', 'showLineHeight', 'showLetterSpacing']
            drop.forEach(t => {
            if (t === type)
                this[type] = !this[type];
            else
                this[t] = false;
            })

            return false;
        },
        changeFontFamily(font) {
            // 字体改变
            /*let command = {
            cmd: 'fontName',
            val: `"${font}"`
            }*/
            this.familySelect = font.value;
            this.myEditStyle.fontFamily=this.familySelect;
            this.data.value.familySelect=this.familySelect;
            //this.doCommand(command);
        },
        moreFont() {
            // 更多字体
            this.$bus.emit('FeaturesPop_vue', {
                name: 'fontFamily',
                posx: parseInt(this.editSetting.left) + this.MaterialPane_Size.width - 130,
                posy: parseInt(this.editSetting.top) + this.TopNav_Size.height - 30,
                type: 1,
                from: 'richTextEdit',
            });
        },
        focusF(type) {
            // 输入框的聚焦后编辑文本的丢失
            this.selection = window.getSelection().getRangeAt(0);
            this[type + 'F'] = this[type]
        },
        blurF(type) {
            // 重新设置丢失后的编辑文本选择
            let e = window.getSelection()
            e.removeAllRanges();
            e.addRange(this.selection)
            this.selection = null;
            if(this[type + 'F'] !== this[type]) {
            if(type === 'fontSize') {
                let val = Math.round(this.fontSize)
                if(val > 500) {
                  val = 500;
                }else if(val < 6) {
                  val = 6;
                }
                this.fontSize = val;
                this.changeFontSize()
            } else if(type === 'lineHeight') {
                this.changeLineHeight()
            } else if(type === 'letterSpacing') {
                this.changeLetterSpacing()
            }
            }
        },
        clickChangeSize(s) {
            // 改变字体大小
            if(s !== this.fontSize) {
              this.fontSize = s;
              this.changeFontSize();
            }
        },
        clickChangeLine(l) {
            // 改变行高
            if(l !== this.lineHeight) {
            this.lineHeight = l
            this.changeLineHeight()
            }
        },
        clickChangeLetter(l) {
            // 改变字间距
            if(l !== this.letterSpacing) {
            this.letterSpacing = l
            this.changeLetterSpacing()
            }
        },
        addReduSize(v) {
            // 输入框改变字体大小
            v = this.fontSize + v
            if(v < 6)
            this.fontSize = 6;
            else if(v > 500)
            this.fontSize = 500;
            else
            this.fontSize = v
            this.changeFontSize();
        },
        setFontColor(){
          this.doCommand({cmd: "ForeColor", val: this.foreColor});
        },
        doCommand(command) {
            // 对应的富文本编辑各种命令
            if(command.cmd === 'letterSpacing') {
                document.execCommand('subscript', false, '');
            } if(command.cmd === 'lineHeight') {
                this.$refs.myEdit.style.lineHeight = command.val
            } else {
                document.execCommand(command.cmd, false, command.val);
            }
            // font-size有待改进
            let ee = window.getSelection();

            if(ee.focusNode && ee.focusNode.parentNode) {
              let doms = null;
              if(command.cmd === 'letterSpacing') {
                  doms = this.$refs.myEdit.querySelectorAll('[style*="vertical-align: sub;"]')
                  let str = '';
                  str=command.val/100 + 'em'
                  doms.forEach((dom) => {
                    dom.style.verticalAlign = '';
                    dom.style.letterSpacing = str;
                  })
              } else if(command.cmd === 'fontSize') {
                  //let selObj = window.getSelection();
                  //if(this.isNull(selObj.toString()))this.myEditStyle.fontSize=command.val+"px";
                  
                  doms = this.$refs.myEdit.querySelectorAll('[style*="font-size: xxx-large;"]')
                  if(!doms.length) doms = this.$refs.myEdit.querySelectorAll('[style*="font-size: -webkit-xxx-large;"]')
                  if(!doms.length) doms = this.$refs.myEdit.querySelectorAll('font[size*="7"]')
                  doms.forEach((dom) => {
                      dom.style.fontSize = command.val + 'px';
                      dom.size="";
                      //dom.outerHTML='<font style="font-size: '+command.val+'px;" data-size="'+parseFloat(command.val)+'">'+dom.innerHTML+'</font>';
                  })
              }
              doms = null;
            }
        },
        changeFontSize() {
            this.doCommand({cmd: 'fontSize', val: this.fontSize});
        },
        changeBasic(c) {
            this.doCommand({cmd: c.cmd, val: ''});
        },
        changejustify(cmd) {
            this.data.value.horizontalAlign=(cmd=="left")?0:((cmd=="right")?2:1);
            this.myEditStyle.textAlign=cmd;
        },
        changeLineHeight() {
            this.myEditStyle.lineHeight=this.lineHeight;
            this.doCommand({cmd: 'lineHeight', val: this.lineHeight})
        },
        changeLetterSpacing() {
            this.doCommand({cmd: 'letterSpacing', val: this.letterSpacing})
        },
        synch() {
            // 每次切换光标的对应字体大小，颜色等
            let style = window.getComputedStyle(window.getSelection().focusNode.parentElement, null);
            if(style.fontFamily) {
                for(let i in this.downFonts) {
                    let str = this.downFonts[i].value.split("/").pop()
                    if(style.fontFamily.replace(/'|"/g, "") === str) {
                    this.fontFamily = this.downFonts[i].label;
                    break;
                    }
                }
            }else {
                this.fontFamily = this.downFonts[0].label;
            }
            if(style.fontSize) {
                this.fontSize = parseInt(style.fontSize);
            } else {
                this.fontSize = 40;
            }
            if(style.color) {
                this.foreColor = style.color
            }
            style = null;
            
            document.execCommand('formatBlock', 'false', '<p>')
        },
        paste(e) {
            // 粘贴处理，防止复制过来了样式
            e.preventDefault();
            e.stopPropagation();
            let text = "";
            let clp = (e.originalEvent || e).clipboardData;
            if (clp === undefined || clp === null) {
                text = window.clipboardData.getData("text");
                if (text !== "") {
                    if (window.getSelection) {
                        let newNode = document.createElement("span");
                        newNode.innerHTML = text;
                        window.getSelection().getRangeAt(0).insertNode(newNode);
                    } else {
                        document.selection.createRange().pasteHTML(text);
                    }
                }
            } else {
                text = clp.getData('text/plain');
                if (text !== "") {
                    this.doCommand({cmd: 'insertText', val: text})
                }
            }
        },
        exit() {
            //let htmlData={lineHeight:this.lineHeight,html:this.$refs.myEdit.innerHTML}
            // 退出编辑模式（保存富文本）
            //this.resetFontSize("toCocos");
            this.data.value.shangxia=this.lineHeight;
            this.data.value.lineHeight=this.lineHeight;
            //this.data.value.fontSize=parseFloat(this.myEditStyle.fontSize);
            this.data.value.text=this.htmlToCocos();
            this.data.value.html=this.$refs.myEdit.innerHTML;//JSON.stringify(htmlData);
            this.$emit('updateTextFont', this.data);
            this.dialogVisible = false;

            /*
            if(option.html !== '<br>' && this.richText !== option.html || this.writingMode !== this.sprite.versionAnyway || this.lineHeight !== s.lineHeight) {
                this.fontSizeF = 8;
                this.useFontFamily = new Set();
                this.traversal(this.$refs.myEdit);
                this.useFontFamily.forEach(v => {
                    for(let i in this.downFonts) {
                    if(this.downFonts[i].value.indexOf(v.replace(/'|"/g, "")) !== -1) {
                        option.fontList.push(this.downFonts[i].value);
                        option.resourceIds.push(this.downFonts[i].id);
                        break;
                    }
                    }
                })
                option.maxSize = this.fontSizeF;
                option.text = this.$refs.myEdit.innerText.slice(0, 3)
            }*/
        },
        traversal(node) {
            //对node的遍历处理
            if (node && node.nodeType === 1) {
                if(node.style.fontSize && parseInt(node.style.fontSize) > this.fontSizeF) this.fontSizeF = parseInt(node.style.fontSize)
                if(node.style.fontFamily) this.useFontFamily.add(node.style.fontFamily);
            }
            let i = 0,
                childNodes = node.childNodes,
                item;
            for (; i < childNodes.length; i++) {
                item = childNodes[i];
                if (item.nodeType === 1) {
                    //递归先序遍历子节点
                    this.traversal(item);
                }
            }
        },
        handleSend(){
            this.data.value.text=this.htmlToCocos(this.editorText.txt.html());
            this.$emit('updateTextFont', this.data)
            this.editorText.txt.clear()
            this.close()
            //this.editorText.destroy();
        },
        htmlToCocos(){//网页代码转COCOS代码
            let doms = null;
            let fontSizeArr=[12];
            let size=0;
            let newdom="";
            let value=this.$refs.myEdit.innerHTML;//this.htmlToTxt(this.$refs.myEdit.innerHTML);
            doms = this.$refs.myEdit.querySelectorAll('font,span,i,u,b')
            doms.forEach((dom) => {
                newdom=dom.innerHTML;
                if(!this.isNull(dom.color))newdom='<color='+dom.color+'>'+newdom+'</color>';
                if(!this.isNull(dom.style.fontSize)){
                  //size=parseInt(parseFloat(dom.style.fontSize)/(this.data.value.position.scale))
                  size=parseFloat(dom.style.fontSize);
                  newdom='<size='+size+'>'+newdom+'</size>';
                  fontSizeArr.push(size);
                }
                if(dom.nodeName=="U")newdom='<u>'+newdom+'</u>';
                if(dom.nodeName=="I")newdom='<i>'+newdom+'</i>';
                if(dom.nodeName=="B")newdom='<b>'+newdom+'</b>';
                
                value=value.replace(dom.outerHTML,newdom);
            })
            this.data.value.shangxia=(Math.max(...fontSizeArr)/2)*this.lineHeight;

            doms = null;
            return this.htmlToTxt(value);
        },
        cocosToHTML(value){//COCOS代码转网页代码
            value=value.replace(/<outline color="(.*?)" width="(.*?)">(.*?)<\/outline>/g,'<outline style="text-stroke:$2px $1;">$3</outline>');
            value=value.replace(/<\/color>/g,'</font>');
            value=value.replace(/<\/size>/g,'</font>');
            value=value.replace(/<\/color><\/size>/g,'</font>');
            value=value.replace(/<\/size><\/color>/g,'</font>');

            value=value.replace(/<color=(.*?)><size=(.*?)>/g,'<font color="$1" style="font-size: $2px;">');
            value=value.replace(/<size=(.*?)><color=(.*?)>/g,'<font color="$2" style="font-size: $1px;">');
            value=value.replace(/<color=(.*?)>/g,'<font color="$1">');
            value=value.replace(/<color="(.*?)">/g,'<font color="$1">');
            value=value.replace(/<size="(.*?)">/g,'<font style="font-size: $1px;">');
            value=value.replace(/<size=(.*?)>/g,'<font style="font-size: $1px;">');
            return value;
        },
        htmlToTxt(value){
            //将代码转义，保证保留当前代码
            value=value.replace(/\r\n/g,'');
            value=value.replace(/\n/g,'');
            value=value.replace(/<p><\/p>/g,'');
            value=value.replace(/<color(.*?)>(.*?)<\/color>/g,'[color$1]$2[/color]');
            value=value.replace(/<size(.*?)>(.*?)<\/size>/g,'[size$1]$2[/size]');
            value=value.replace(/<p(.*?)>(.*?)<\/p>/g,'$2[br]');
            value=value.replace(/<div(.*?)>(.*?)<\/div>/g,'$2[br]');
            value=value.replace(/<li(.*?)>(.*?)<\/li>/g,'$2[br]');
            value=value.replace(/<span(.*?)>(.*?)<\/li>/g,'$2[br]');
            value=value.replace(/<h1(.*?)>(.*?)<\/h1>/g,'$2[br]');
            value=value.replace(/<h2(.*?)>(.*?)<\/h2>/g,'$2[br]');
            value=value.replace(/<h3(.*?)>(.*?)<\/h3>/g,'$2[br]');
            value=value.replace(/<h4(.*?)>(.*?)<\/h4>/g,'$2[br]');
            value=value.replace(/<h5(.*?)>(.*?)<\/h5>/g,'$2[br]');
            value=value.replace(/<h6(.*?)>(.*?)<\/h6>/g,'$2[br]');
            value=value.replace(/<strong>(.*?)<\/strong>/g,'[b]$1[/b]');
            value=value.replace(/<b>(.*?)<\/b>/g,'[b]$1[/b]');
            value=value.replace(/<i>(.*?)<\/i>/g,'[i]$1[/i]');
            value=value.replace(/<u>(.*?)<\/u>/g,'[u]$1[/u]');
            value=value.replace(/<br\/>/g,'[br/]');
            value=value.replace(/<br>/g,'[br/]');
            //过滤所有无用标签
            value=value.replace(/<(.*?)>/g,'');
            value=value.replace(/<\/(.*?)>/g,'');
            //将[]转化为html
            value=value.replace(/\[(.*?)\]/g,'<$1>');

            //去除最后一个<br/>
            /*let valueArr=value.split("<br/>");
            valueArr.pop();
            let valueStr=valueArr.join("<br/>");
            value=valueStr;*/

            return value;
        },
        isJSON(str) {
            if (typeof str == 'string') {
                try {
                    var obj=JSON.parse(str);
                    if(typeof obj == 'object' && obj ){
                        return true;
                    }else{
                        return false;
                    }

                } catch(e) {
                    console.log('error：'+str+'!!!'+e);
                    return false;
                }
            }
            console.log('It is not a string!')
        },
        isNull(v){
          switch (typeof v) {
          case 'undefined':
              return true;
          case 'string':
              if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true;
              break;
          case 'boolean':
              if (!v) return true;
              break;
          case 'number':
              if (0 === v || isNaN(v)) return true;
              break;
          case 'object':
              if (null === v || v.length === 0) return true;
              for (var i in v) {
                  return false;
              }
              return true;
          }
          return false;
        },
         /**
         * php preg_match_all的实现
         * @param {*} data 数据
         * @param {*} exp 正则表达式
         */
        matchAll(data) {
            let regex = /<color="(.*?)">/g;
            let Regex = new RegExp(regex, 'mg');
            let Matches = data.match(Regex);
            let matchesArray = new Array();
            for (let i in Matches) {
                //let nvarr=regex.exec(Matches[i]);
                let ngRegex = new RegExp(regex);
                let ngMatches = Matches[i].match(ngRegex);
                matchesArray.push(ngMatches);
            }
            return matchesArray;
        },
        colorHex(_rgb){
            let that = _rgb;
            //十六进制颜色值的正则表达式
            let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
            // 如果是rgb颜色表示
            if (/^(rgb|RGB)/.test(that)) {
                let aColor = that.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
                let strHex = "#";
                for (let i=0; i<aColor.length; i++) {
                    let hex = Number(aColor[i]).toString(16);
                    if (hex.length < 2) {
                        hex = '0' + hex;    
                    }
                    strHex += hex;
                }
                if (strHex.length !== 7) {
                    strHex = that;    
                }
                return strHex;
            } else if (reg.test(that)) {
                let aNum = that.replace(/#/,"").split("");
                if (aNum.length === 6) {
                    return that;    
                } else if(aNum.length === 3) {
                    let numHex = "#";
                    for (let i=0; i<aNum.length; i+=1) {
                        numHex += (aNum[i] + aNum[i]);
                    }
                    return numHex;
                }
            }
            return that;
        }
    },
};
</script>

<style lang="scss" scoped>

.rich-text-edit {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 20170427520;
  * {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}
.edit-content {
  position: absolute;
  box-sizing: content-box;
  border: 1px dashed #000;
  overflow-y: auto;
  transform-origin: 0% 0% 0px;
  p{
    margin:22px 0px;
  }
}
.my-edit {
  outline: none;
  text-align: center;
  transform-origin: 0px 0px 0px;
  overflow: hidden;
}
.edit-setting {
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  width: 308px;
  height: 80px;
  padding: 5px;
  border: 1px solid #DEDEE7;
  border-radius: 5px;
  background-color: #fff;
  color: #474261;
  z-index: 50;
  font-size:14px;

  .line {
    height: 20px;
    margin-top: 6px;
    border-right: 1px solid #EFEFF7;
  }
  i{
    width:24px;
    height: 24px;
    float:left;
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
  }
    input[type=number] {  
        -moz-appearance:textfield;  
    }  
    input[type=number]::-webkit-inner-spin-button,  
    input[type=number]::-webkit-outer-spin-button {  
        -webkit-appearance: none;  
        margin: 0;  
    }  
}
.edit-fontFamily {
  width: 103px;
  height: 30px;
  position: relative;
  top: 0;
  left: 0;
  line-height: 28px;
  border: 1px solid #EFEFF7;
  border-radius: 3px;

  p {
    width: 105px;
    height: 30px;
    overflow: hidden;
    margin-left: 5px;
    text-align: left;
  }

  .icon-rich-text-drop {
    position: absolute;
    top: 4px;
    right: 0px;
    background-color: #ffffff;
  }

  .rich-dropdown {
    position: absolute;
    top: 31px;
    left: 0px;
    min-width: 130px;
    padding: 8px 0;
    border-radius: 5px;
    box-shadow: 0 0 3px rgba(0,0,0,.16);
    background-color: #fff;
    >div {
      width: 140px;
      height: 30px;
      padding-left: 13px;
      line-height: 30px;
      text-align: left;
      cursor: pointer;

      &.active{
        background-color: #1593ff;
        color: #fff;
      }
      &:not(.active):not(.more-fontFamily):hover {
        background-color: #eee;
      }
    }
    .more-fontFamily {
      width: 80px;
      background-color: #1593ff;
      color: #fff;
      border-radius: 5px;
      margin: 0 auto;
      text-align: center;
      padding: 0;
    }
  }
}
.edit-fontSize {
  width: 130px;
  height: 30px;
  line-height: 30px;
  margin-left: 6px;
  display: flex;

  input {
    width: 38px;
    height: 30px;
    border-radius: 3px;
    border: 1px solid #EFEFF7;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    text-align: center;
    font-weight: bold;
    color: #474261;
  }
  .add-size, .redu-size {
        margin-top:4px;
        margin-left:4px;
        width: 24px;
        height: 24px;
        cursor: pointer;
  }
}
.size-dropdown {
  position: relative;
  width: 28px;
  height: 30px;
  line-height: 28px;
  top: 0;
  left: 0;
  z-index: 1000000;
  border: 1px solid #EFEFF7;
  border-left: 0;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  cursor: pointer;
  i{
      margin-top:3px;
  }
}
.size-drop-box {
  position: relative;
  top: 2px;
  left: -38px;
  width: 66px;
  height: auto;
  overflow-y: hidden;
  padding: 8px 0;
  border-radius: 5px;
  box-shadow: 0 0 3px rgba(0,0,0,.16);
  background-color: #fff;
}
.size-drop-box > div > div {
  height: 30px;
  width:  66px;
  text-align: center;
  &:hover {
    background-color: #EFEFF7;
  }
}
.vb-content {
  overflow-x: hidden !important;
}
.edit-color {
    margin-left:8px;
  height: 24px;
  width: 50px;
  line-height: 24px;
  display: flex;
  justify-content: space-between;

  div {
    width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 18px;
    cursor: pointer;

    &:last-child {
      padding-top: 2px;
    }
  }

  span {
      margin-top:3px;
    height: 22px;
    width: 14px;
    border-bottom: 2px solid;
    border-color: #474261;
    display: inline-block;
  }
}
.edit-mode {
  width: 30px;
  height: 30px;
  padding:6px;
  margin-left: 4px;
  cursor: pointer;
}
.edit-basic {
  width: 93px;
  height: 30px;
  padding-top: 5px;
  display: flex;
  padding-right: 10px;
  justify-content: space-between;

  div {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}
.edit-layout {
  height: 30px;
  width: 195px;
  line-height: 30px;
  display: flex;
  padding: 0 0px 0px 6px;
  justify-content: space-between;

  .layout-justify {
    width: 82px;
    padding: 4px 0;
    display: flex;
    justify-content: space-between;

    >div {
      height: 24px;
      width: 24px;
      cursor: pointer;
      margin-left: 5px;
      margin-right: 10px;
    }
  }

  .layout-lineHeight,.layout-letterSpacing {
    position: relative;
    top: 0;
    left: 0;
    width: 64px;
    height: 30px;
    border: 1px solid #EFEFF7;
    border-radius: 4px;

    >div:first-child {
      width: 64;
      height: 30px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      cursor: pointer;
    }
  }

  .layout-letterSpacing {
    width: 55px;
    >div:first-child {
      width: 55px;
    }
  }

  .lineHeight-dropdown,.letterSpacing-dropdown {
    position: absolute;
    top: 100%;
    left: 0px;
    width: 62px;
    padding-top: 8px;
    border-radius: 5px;
    box-shadow: 0 0 3px rgba(0,0,0,.16);
    background-color: #fff;
    text-align: center;

    input {
      width: 52px;
      height: 24px;
      margin: 0 auto;
      border: 1px solid #EFEFF7;
      text-align: center;
    }

    >div {
      cursor: pointer;

      &:hover {
        background-color: #EFEFF7;
      }
    }
  }

  .letterSpacing-dropdown {
    width: 54px;

    input {
      width: 45px;
    }
  }
}
.edit-remove {
  width: 30px;
  height: 30px;
  padding:6px;
  cursor: pointer;
}
.yanse-box{
  top:-30px;
  z-index: 20170427520;
}
.icon-rich-text-drop{
    background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjI0OTcyODAzNjM3IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjEwMDAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNODcwLjU3MDY2NyAzNDQuNTE5MTExYTM2LjAxMDY2NyAzNi4wMTA2NjcgMCAwIDEgNTEuMzEzNzc3IDUwLjUxNzMzM2wtMC40NTUxMTEgMC4zOTgyMjMtMzg0IDM4NGEzNi4wMTA2NjcgMzYuMDEwNjY3IDAgMCAxLTUwLjQ2MDQ0NCAwLjQ1NTExMWwtMC4zOTgyMjItMC40NTUxMTEtMzg0LTM4NGEzNi4wMTA2NjcgMzYuMDEwNjY3IDAgMCAxIDUwLjQ2MDQ0NC01MS4zMTM3NzhsMC4zOTgyMjIgMC4zOTgyMjJMNTEyIDcwMy4xNDY2NjdsMzU4LjU3MDY2Ny0zNTguNTcwNjY3eiIgcC1pZD0iMTAwMSI+PC9wYXRoPjwvc3ZnPg==') ;
}

.icon-rich-text-bold{
    background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjI1MDE3NTc3NDMwIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjQ1NTEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNMjgzIDg3NVYxNDloMjEzLjFjNjMuNyAwIDExNC42IDE1LjIgMTUyLjcgNDUuNyAzOC4xIDMwLjUgNTcuMSA3MC45IDU3LjEgMTIxLjIgMCA0MC0xMS4zIDc1LjMtMzQgMTA1LjktMjIuNiAzMC42LTUzLjggNTIuMy05My40IDY1LjF2MS45YzQ5LjMgNS42IDg4LjcgMjQuMyAxMTguMiA1NlM3NDEgNjE2LjcgNzQxIDY2NS41YzAgNjIuNS0yMi40IDExMy02Ny4yIDE1MS42QzYyOSA4NTUuNyA1NzEuNiA4NzUgNTAxLjcgODc1SDI4M3ogbTkzLjctNjQ0djIyNy4zaDg1LjJjNDUuMyAwIDgwLjgtMTEgMTA2LjUtMzMgMjUuOC0yMiAzOC42LTUyLjYgMzguNi05MS42IDAtNjguNC00NS42LTEwMi42LTEzNi43LTEwMi42aC05My42eiBtMCAzMDguOVY3OTNoMTEyLjRjNDkgMCA4Ni45LTExLjMgMTEzLjYtMzQgMjYuNy0yMi43IDQwLTU0LjEgNDAtOTQuNCAwLTgzLjEtNTYuNC0xMjQuNy0xNjkuMS0xMjQuN2gtOTYuOXoiIGZpbGw9IiMyYzJjMmMiIHAtaWQ9IjQ1NTIiPjwvcGF0aD48L3N2Zz4=');
}
.icon-rich-text-italic{
    background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjI1MDE3NTU3NzkxIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjQzNzYiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNNDQ2LjYgMTkydjY0aDEyOC41bC0yNTUgNTEySDE5MnY2NGgzODUuNHYtNjRINDQ3LjlsMjU1LTUxMkg4MzJ2LTY0eiIgZmlsbD0iIzJjMmMyYyIgcC1pZD0iNDM3NyI+PC9wYXRoPjwvc3ZnPg==');
}
.icon-rich-text-under{
    background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjI1MDE3NTA5NzgwIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjExNjEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNMjQ0LjgwMzkxMTk2IDkzMC4yNjMzNjgwNXYtNTMuMzA4MzAzNDNsNTM0LjM5MjE3NjA4LTQuODQ5MDY1NjF2NTMuMjk3ODMwMjNMMjQ0LjgwMzkxMTk2IDkzMC4yNjMzNjgwNXpNNzUzLjc5ODcxMzc4IDUyMS40MTI3Njk2NXEwIDI3My41MDYxNTcxOS0yNDguMTA4NzgyOTEgMjczLjUwNjE1Nzk3LTIzNy43NDAzNzAyNSAwLTIzNy43NDAzNzAyNy0yNjMuOTIzMjMwNzhWMTM5LjMwMDEwODQ0aDgzLjI2MTQ5NTE0djM4Ny45MzU3Mjk2OXEwIDE5My41NzUxMjIxMSAxNjIuMzMzNzMyODggMTkzLjU3NTEyMjEgMTU2Ljk0MDA2Mzg1IDAgMTU2Ljk0MDA2Mzg2LTE4Ny4zMzMxMjgyVjEzOS4yNDc3NDMwNUg3NTMuNzk4NzEzNzh6IiBmaWxsPSIiIHAtaWQ9IjExNjIiPjwvcGF0aD48L3N2Zz4=');
}
.icon-rich-text-left{
    background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjI1MDE5NDYxMDAyIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwOTcgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjEwMzQiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjE0LjI1NzgxMjUiIGhlaWdodD0iMjAwIj48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik0zNy43NDE3MTQgMTUxLjc3MTQyOXYtMTA5LjcxNDI4NmgxMDIxLjY1OTQyOXYxMDkuNzE0Mjg2SDM3Ljc0MTcxNHogbS0xLjQ2Mjg1NyAyNzUuNzQ4NTcxdi0xMDkuNzE0Mjg2aDU4NS4yODkxNDN2MTA5LjcxNDI4NkgzNi4yNzg4NTd6TTM1LjAzNTQyOSA3MTcuMzg1MTQzdi0xMDkuNzE0Mjg2aDEwMjYuMTk0Mjg1djEwOS43MTQyODZIMzUuMTA4NTcxeiBtMS4yNDM0MjggMjczLjk5MzE0M3YtMTA5LjcxNDI4Nmg1ODUuNzI4djEwOS43MTQyODZIMzYuMjc4ODU3eiIgZmlsbD0iIzJjMmMyYyIgcC1pZD0iMTAzNSI+PC9wYXRoPjwvc3ZnPg==');
}
.icon-rich-text-center{
    background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjI1MDE5NDY1Nzg0IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwOTcgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjEyMDEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjE0LjI1NzgxMjUiIGhlaWdodD0iMjAwIj48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik0zNi4wNTk0MjkgMTQ3LjM4Mjg1N3YtMTA5LjcxNDI4NkgxMDYwLjU3MTQyOXYxMDkuNzE0Mjg2SDM2LjA1OTQyOXogbTIxOS43OTQyODUgMjgyLjkxNjU3MnYtMTA5LjcxNDI4Nmg1ODIuMTQ0djEwOS43MTQyODZIMjU1Ljg1MzcxNHpNMzguOTg1MTQzIDcxOC4yNjI4NTd2LTEwOS43MTQyODZoMTAyMi40NjR2MTA5LjcxNDI4NkgzOC45ODUxNDN6IG0yMjAuMzA2Mjg2IDI3OC42NzQyODZ2LTEwOS43MTQyODZoNTc5LjY1NzE0MnYxMDkuNzE0Mjg2SDI1OS4yOTE0Mjl6IiBmaWxsPSIjMzMzMzMzIiBwLWlkPSIxMjAyIj48L3BhdGg+PC9zdmc+');
}
.icon-rich-text-right{
    background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjI1MDE5NDY5MDg2IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwOTcgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjEzMzQiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjE0LjI1NzgxMjUiIGhlaWdodD0iMjAwIj48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik0zOS43MTY1NzEgMTUzLjZWNDMuODg1NzE0aDEwMjEuMDc0Mjg2djEwOS43MTQyODZIMzkuNzE2NTcxeiBtNDM3LjAyODU3MiAyNzYuMTg3NDI5di0xMDkuNzE0Mjg2aDU4NS4yODkxNDN2MTA5LjcxNDI4Nkg0NzYuNzQ1MTQzek0zNy4wODM0MjkgNzE0LjMxMzE0M3YtMTA5LjcxNDI4NkgxMDYwLjU3MTQyOXYxMDkuNzE0Mjg2SDM3LjA4MzQyOXogbTQ0MC4xNzM3MTQgMjc2LjY5OTQyOHYtMTA5LjcxNDI4NWg1NzguNDEzNzE0djEwOS43MTQyODVINDc3LjI1NzE0M3oiIGZpbGw9IiMzMzMzMzMiIHAtaWQ9IjEzMzUiPjwvcGF0aD48L3N2Zz4=');
}
.icon-rich-text-line{
    background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjI1MDE5NzIwOTAyIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwOTcgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE0NjciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjE0LjI1NzgxMjUiIGhlaWdodD0iMjAwIj48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik0zNy44ODggMTU1LjM1NTQyOXYtMTA5LjcxNDI4NmgxMDI0LjIxOTQyOXYxMDkuNzE0Mjg2SDM3Ljg4OHpNNDc2Ljg5MTQyOSA0NDUuOTUydi0xMDkuNzE0Mjg2aDU4NC4yNjUxNDJ2MTA5LjcxNDI4Nkg0NzYuODkxNDI5eiBtMC44Nzc3MTQgMjI1LjcxODg1N3YtMTA5LjcxNDI4Nmg1ODIuNjU2djEwOS43MTQyODZINDc3LjYyMjg1N3pNNDAuMjI4NTcxIDk1OC4wMjUxNDN2LTEwOS43MTQyODZoMTAxOC41ODc0Mjl2MTA5LjcxNDI4Nkg0MC4yMjg1NzF6IG0tNDAuMzAxNzE0LTUxNC45MjU3MTRsMTgxLjgzMzE0My0xNzIuNjkwMjg2TDM2My41MiA0NDMuMTcyNTcxSC0wLjA3MzE0M3ogbTEuOTc0ODU3IDE0OC43NzI1NzFoMzYzLjMwMDU3MkwxODMuNTg4NTcxIDc2Mi42NjA1NzEgMS45MDE3MTQgNTkxLjg3MnoiIGZpbGw9IiMzMzMzMzMiIHAtaWQ9IjE0NjgiPjwvcGF0aD48L3N2Zz4=');
}
.icon-rich-text-letter{
    background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjI1MDE5NzI2NDQwIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE2MDAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNMzMuNDUwNjY3IDMuNDEzMzMzaDEwMi40djk1Ni44MjU2SDMzLjQ1MDY2N1YzLjQxMzMzM3ogbTg4Ny4zMzAxMzMgMS44NDMyaDEwMi40djk1Ny43MTMwNjdoLTEwMi40VjUuMTg4MjY3eiBtLTQyNS4zMDEzMzMgMjAwLjcwNGgxMDguOTUzNmwyMjMuNjQxNiA1ODQuOTc3MDY3aC0xMDIuNGwtNTMuMjQ4LTE0Ni42MzY4SDQyNy40ODU4NjdsLTUzLjI0OCAxNDYuNjM2OGgtMTAyLjRsMjIzLjY0MTYtNTg0LjkwODh6IG0tMzkuMzIxNiAzNTkuNjk3MDY3SDY0My43NTQ2NjdMNTUyLjAwNDI2NyAzMDkuMjQ4aC0zLjI3NjhMNDU2LjE1Nzg2NyA1NjUuNjU3NnoiIGZpbGw9IiMzMzMzMzMiIHAtaWQ9IjE2MDEiPjwvcGF0aD48L3N2Zz4=');
}
.icon-rich-text-remove{
    margin-top:3px;
    background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjI1MDE3NTUyNzMxIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjQxOTciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNNDc1IDc2OUwxOTUgNDg5IDU4Ny45IDk2IDg2OCAzNzYuMSA0NzUgNzY5eiBtLTQzLjYgNDMuN0wxNTEuMyA1MzIuNiA2NCA2MTkuOSAzNDQuMSA5MDBsODcuMy04Ny4zeiIgZmlsbD0iIzJjMmMyYyIgcC1pZD0iNDE5OCI+PC9wYXRoPjxwYXRoIGQ9Ik00NDggODY0aDUxMnY2NEg0NDh6IiBmaWxsPSIjMmMyYzJjIiBwLWlkPSI0MTk5Ij48L3BhdGg+PC9zdmc+');
}
.icon-fontsize-add{
    background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjI1MDM0NTYxMTA1IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjQyNDIiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNNzE4IDk2MEg2MTQuM2wtNzQuMS0xOTIuN0gyMzcuNkwxNjcuNyA5NjBINjRsMjc2LjgtNzA0aDEwMC40TDcxOCA5NjB6TTUxMS4xIDY4Ny44TDQwMS4zIDM5NS4xYy0zLjQtOS40LTcuMi0yNS43LTExLjMtNDkuMWgtMi4zYy0zLjQgMjEuMi03LjQgMzcuNi0xMS43IDQ5LjFMMjY3LjEgNjg3LjhoMjQ0eiIgZmlsbD0iIzJjMmMyYyIgcC1pZD0iNDI0MyI+PC9wYXRoPjxwYXRoIGQ9Ik04MDAgNjRMNjQwIDI1NmgzMjB6IiBmaWxsPSIjMmMyYzJjIiBwLWlkPSI0MjQ0Ij48L3BhdGg+PC9zdmc+');
}
.icon-fontsize-cut{
    background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjI1MDM0NTU0ODQ0IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjQwNjIiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNNjAwIDk2MGgtODVsLTYwLjgtMTU4LjJoLTI0OEwxNDkgOTYwSDY0bDIyNi45LTU3OGg4Mi4zTDYwMCA5NjB6TTQzMC40IDczNi41bC05MC0yNDAuM2MtMi44LTcuNy01LjktMjEuMS05LjItNDAuM2gtMS45Yy0yLjggMTcuNC02IDMwLjgtOS42IDQwLjNsLTg5LjIgMjQwLjNoMTk5Ljl6IiBmaWxsPSIjMmMyYzJjIiBwLWlkPSI0MDYzIj48L3BhdGg+PHBhdGggZD0iTTgwMCAyNTZMNjQwIDY0aDMyMHoiIGZpbGw9IiMyYzJjMmMiIHAtaWQ9IjQwNjQiPjwvcGF0aD48L3N2Zz4=');
}
</style>